import { render, staticRenderFns } from "./communitySpaceManageList.vue?vue&type=template&id=15810c24&scoped=true"
import script from "./communitySpaceManageList.vue?vue&type=script&lang=js"
export * from "./communitySpaceManageList.vue?vue&type=script&lang=js"
import style0 from "./communitySpaceManageList.vue?vue&type=style&index=0&id=15810c24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15810c24",
  null
  
)

export default component.exports